export const Z_AXIS_SEPRATAION=68
export const AXIS_ON='On'
export const AXIS_OFF='Off'
export const ZAXIS='zAxis'


export const YAXIS_DATATYPE ='yaxisDataType'
export const XAXIS_DATATYPE ='xaxisDataType'

export const PREDICITON_MODE ='prediction'
export const NOPREDICITON_MODE ='noprediction'